import { TaskResult } from '@/tasks/TaskResult';
import { useState } from 'react';
import { useOperation, useTwinTask } from '@/api/hooks';
import { failureOf, said } from '@/api/errors';

/** Read the permitted, already-shaped result at source. No raw credentials or
 * provider response is fetched merely to expand a conversational summary. */
export function OperationResultReference({ id }: { id: string }) {
  const [open, setOpen] = useState(false);
  const q = useOperation(open ? id : null);
  return <div className="border border-line p-3 space-y-2">
    <button className="underline min-h-11" onClick={() => setOpen(v => !v)}>{open ? 'Hide full result' : 'Read full result here'}</button>
    {open && (q.isPending ? <p role="status">Reading the original result…</p> : q.isError ? <p role="alert">{said(failureOf(q.error))}</p> : <>
      <p>{q.data.operation.summary ?? q.data.operation.state}</p>
      <pre className="whitespace-pre-wrap break-words overflow-x-auto">{JSON.stringify(q.data.operation.result, null, 2)}</pre>
      {q.data.operation.events.map((e, i) => <p key={i}>{e.at}: {e.summary ?? e.state}</p>)}
    </>)}
  </div>;
}

export function TaskResultReference({ id }: { id: string }) {
  const [open, setOpen] = useState(false);
  return <div className="border border-line p-3 space-y-2"><button className="underline min-h-11" onClick={() => setOpen(value => !value)}>{open ? 'Hide task result' : 'Read full task result here'}</button>{open && <OriginalTaskResult id={id} />}</div>;
}
function OriginalTaskResult({ id }: { id: string }) {
  const q = useTwinTask(id);
  if (q.isPending) return <p role="status">Reading the original task…</p>;
  if (q.isError) return <p role="alert">{said(failureOf(q.error))}</p>;
  const results = q.data.task.evidence.filter(item => item.kind === 'result');
  return <><p>{q.data.task.title} · {q.data.task.state}</p>{results.length ? results.map(result => <TaskResult key={result.seq} evidence={result} />) : <p>No result has been recorded yet.</p>}</>;
}
